(function() {
  'use strict';
  angular.module('cfn').directive('dTristate', function() {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<input type="checkbox" ng-model="state" ng-change="stateChange(state)">',
      scope: {
        indeterminate: '=',
        change: '&'
      },
      link: function(scope, element, attributes) {
        scope.$watch('indeterminate', function(val) {
          if (val) {
            var indeterminate = false,
              checked = false;
            switch (val) {
              case 'none':
                break;
              case 'all':
                checked = true;
                break;
              default:
                indeterminate = true;
            }
            element.prop('indeterminate', indeterminate);
            element.prop('checked', checked);
            //so the watcher sees checked,indet->checked,!indet
            scope.state = checked;
          }
        });
        scope.stateChange = function(changed) {
          var fn = scope.change();
          if (fn) fn(changed);
        };
      }
    };
  });
})();
